import { FixesObj } from "../../util/checkForCommonHardware";

function extractChoiceObj(nonMatches: FixesObj[]) {
  const obj: { [key: string]: string } = {};
  nonMatches.forEach((item: FixesObj) => {
    if (item.objKey) obj[item.objKey as string] = item.choice as string;
    if (item.objKey2) obj[item.objKey2 as string] = item.choice2 as string;
    if (item.objKey3) obj[item.objKey3 as string] = item.choice3 as string;
    if (item.objKey4) obj[item.objKey4 as string] = item.choice4 as string;
  });
  return obj;
}

export { extractChoiceObj };
